(function calendarControlModuleDefinition() {
    'use strict';

    angular.module('CalendarControl', [])
        .constant("moment", moment)
        .directive('calendarControl', ['$translate', 'calendarService', 'calendarConfig', 'errorsExtend', '$state', '$stateParams', 'calendarEventTitle', 'calendarDateFilter',
            function ($translate, calendarService, calendarConfig, errors, $state, $stateParams, calendarEventTitle, calendarDateFilter) {
                return {
                    scope: {
                        events: '=',
                        docTypeId: '=',
                        from: '=',
                        to: '=',
                        callBack: '&redirectEvent',
                        isMonthView: '=',
                        filterDate: '='
                    },
                    link: function (scope, element, attrs) {
                    },

                    controller: [
                        '$scope', '$element', function ($scope) {
                            moment.locale('es');

                            $scope.thisMonth = $scope.to ? $scope.to.month() : moment().month();

                            $scope.viewDate = $scope.filterDate ? $scope.filterDate : moment();

                            if (!$scope.from) {
                                $scope.from = moment().startOf('month');
                            }
                            if (!$scope.to) {
                                $scope.to = moment().endOf('month');
                            }

                            $scope.isMonthView = $scope.isMonthView;
                            calendarConfig.allDateFormats.moment.title.week = "Semana {week} del {year}";
                            calendarConfig.templates.calendarMonthCell = 'app/directives/calendar-control/month-view-cell-template.html';
                            calendarConfig.i18nStrings = {
                                weekNumber: 'Semana {week}'
                            };

                            //Override para que no muestre la hora en los eventos
                            calendarEventTitle.monthView = function (event) {
                                if (event.allDay) {
                                    return event.title;
                                }
                                return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
                            }

                            //Override para que no muestre la hora en los tooltips de los eventos
                            calendarEventTitle.monthViewTooltip = function (event) {
                                if (event.allDay) {
                                    return event.title;
                                }
                                return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
                            }

                            $scope.fillCalendar = function () {
                                if ($scope.docTypeId) {
                                    $scope.events = [];
                                    calendarService.get($scope.docTypeId, new Date($scope.from), new Date($scope.to)).then(function getOk(result) {
                                        result.forEach(function (doc) {
                                            var event = {
                                                startsAt: new Date(doc.eventDate),
                                                color: {
                                                    primary: '#e3bc08',
                                                    secondary: '#fdf1ba'
                                                },
                                                title: doc.docTypeName + ' - ' + doc.numberOfDocuments + (doc.numberOfDocuments > 1 ? ' Documentos' : ' Documento'),
                                                allDay: true,
                                                numberOfDocuments: doc.numberOfDocuments,
                                                label: doc.docTypeName
                                            }
                                            $scope.events.push(event);
                                        })

                                    }, function getError(error) {
                                        errors.showError(error);
                                    });
                                }
                            }

                            $scope.$watch('docTypeId', function () {
                                $scope.fillCalendar();
                            });

                            $scope.previousMonth = function () {
                                this.cellIsOpen = false
                                $scope.from = moment($scope.viewDate).startOf('month');
                                $scope.to = moment($scope.viewDate).endOf('month');
                                $scope.fillCalendar();
                            };

                            $scope.actualMonth = function () {
                                if (moment($scope.viewDate).month() != $scope.from.month()) {
                                    this.cellIsOpen = false
                                    $scope.from = moment($scope.viewDate).startOf('month');
                                    $scope.to = moment($scope.viewDate).endOf('month');
                                    $scope.fillCalendar();
                                }
                            };

                            $scope.nextMonth = function () {
                                this.cellIsOpen = false
                                $scope.from = moment($scope.viewDate).startOf('month');
                                $scope.to = moment($scope.viewDate).endOf('month');
                                $scope.fillCalendar();
                            };

                            calendarConfig.dateFormatter = 'moment';

                            $scope.calendarView = $scope.isMonthView ? 'month' : 'week';

                            $scope.changeView = function (isMonthView) {
                                $scope.isMonthView = isMonthView;
                                $scope.cellIsOpen = false;
                            }

                            $scope.eventClicked = function (event) {
                                if (!$scope.isMonthView) {
                                    $scope.callBack({ eventDate: event.startsAt });
                                }
                            };

                            $scope.timespanClicked = function (date, cell) {
                                if (cell.events.length > 0) {
                                    $scope.callBack({ eventDate: date });
                                }
                            };
                        }],
                    restrict: 'E',
                    templateUrl: '/app/directives/calendar-control/calendar-control.html'
                };
            }
        ]);
})();